import { Component, OnInit } from '@angular/core';
import { NewPlaylistService } from '@core/services/new-playlist.service';
import { Observable } from 'rxjs';
import { NewPlayListInitialState } from '@core/interfaces/new-playlist.interface';

@Component({
  selector: 'app-playlists',
  templateUrl: './playlists.component.html',
  styleUrls: ['./playlists.component.scss']
})
export class PlaylistsComponent implements OnInit {
    public dataSourcePlayListState$: Observable<NewPlayListInitialState> | undefined;

  constructor(
      private _newPlaylistService: NewPlaylistService
  ) {
      this.dataSourcePlayListState$ = this._newPlaylistService.newPlaylistState$.state$;
  }

  ngOnInit(): void {
      this._newPlaylistService.getAllPlayList();
  }

}
